import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "focused-browsing-on",
  "use": "focused-browsing-on-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"focused-browsing-on\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 8a8 8 0 1016 0A8 8 0 000 8zm15 0A7 7 0 111 8a7 7 0 0114 0zm-7 4a4 4 0 100-8 4 4 0 000 8zM3 8a5 5 0 1010 0A5 5 0 003 8zm5 1a1 1 0 100-2 1 1 0 000 2zM6 8a2 2 0 104 0 2 2 0 00-4 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol